export type NativePromoOrigin =
  | 'home_icon'
  | 'gem_shop_icon'
  | 'gem_plus_button'
  | 'launch'
  | 'low_gem_balance';

// both ios and android app
export const nativeAppLaunchUrl = 'co.play.buruburu://main';
export const googlePlayURL =
  'https://play.google.com/store/apps/details?id=co.play.buruburu';
export const appStoreURL =
  'https://apps.apple.com/us/app/ぶるぶるどーぶつ/id1638675792';
export const enabledLevel = 1;

// TEST_APP_INSTALL_NUDGE_POPUP_VARIANT
// Reward for installing native app
export const appInstallReward = { coins: 1000, gems: 100 };
